// keyboard control detection

export const keyboardControl = {
    active: false
}

let accessibilityTimeout = null;
const toggleAccessibilityClass = (mode) => {
    clearTimeout(accessibilityTimeout);
    accessibilityTimeout = setTimeout(() => {
        document.body.classList.toggle('keyboard-control', mode);
        keyboardControl.active = mode;
    }, 100);
}
document.body.addEventListener('keydown', function(e) {
    switch (e.key) {
        case 'Escape':
        case 'Up':
        case 'ArrowUp':
        case 'Down':
        case 'ArrowDown':
        case 'Left':
        case 'ArrowLeft':
        case 'Tab':
        case 'Right':
        case 'ArrowRight':
        case 'PageUp':
        case 'PageDown':
        case 'Spacebar':
        case ' ':
        case 'Enter':
        case 'Return':
            toggleAccessibilityClass(true);
            break;
    }
});
document.body.addEventListener('mousedown', function() {
    toggleAccessibilityClass(false);
});
document.body.addEventListener('touchstart', function() {
    toggleAccessibilityClass(false);
});